<cosmos-image
  *ngIf="_element.image; else compactNoImage"
  [src]="_element.image.url"
></cosmos-image>

<ng-template #compactNoImage>
  <ng-container *ngIf="isCompact else noImage">
    {{ text | trimText: 150 }}
  </ng-container>
</ng-template>

<ng-template #noImage>
  {{ text }}
</ng-template>
